import React, { useEffect, useState, useContext } from "react";
// import Style from "../TermsAndConditions/TermsAndConditions.module.css";
import Style from "./review.module.css";
import { reviewDetailsApi } from "../../Api/services";
import parse from "html-react-parser";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import config from "../../Api/config";

const Review = () => {
  const [reviewDetail, setReviewDetails] = useState({});
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  // Added by - Ashlekh on 10-02-2025
  // Reason - To add useState for storing client testimonial details
  const [clientTestimonialDetails, setClientTestimonialDetails] = useState([]);
  // End of code - Ashlekh on 10-02-2025
  // Reason - To add useState for storing client testimonial details
  const fetchReviewData = async () => {
    const response = await reviewDetailsApi();
    setReviewDetails(response);
    // Added by - Ashlekh on 10-02-2025
    // Reason - To set client testimonial image and description
    setClientTestimonialDetails(response?.client_testimonial_image_and_title)
    // End of code - Ashlekh on 10-02-2025
    // Reason - To set client testimonial image and description
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Review", path: "/review" },
    ]);

    fetchReviewData();
  }, []);

  if (!reviewDetail) return <p>No details available</p>;

  return (
    <div className={Style.mainContainer}>
      <div className={Style.subContainer}>
        <NavigationPath navigationPathArray={navigationPath} />

        {reviewDetail?.review_details?.title ? (
          <div className={Style.title_field}>
            <div className={Style.title}>
              <span className={Style.firstThree}>
                {parse(reviewDetail.review_details.title.slice(0, 3))}
              </span>
              <span className={Style.gradientText}>
                {parse(reviewDetail.review_details.title.slice(3))}
              </span>
            </div>
          </div>
        ) : null}

        {reviewDetail?.review_details?.description ? (
          <div className={Style.description_field}>
            <div className={Style.description}>
              {parse(reviewDetail.review_details.description)}
            </div>
          </div>
        ) : null}

        {/* Added by - Ashlekh on 10-02-2025
        Reason - To display client testimonial details*/}
        {clientTestimonialDetails?.length > 0 && (
          <div className={`${Style.clientTestimonialContainer}`}>
            {clientTestimonialDetails.map((item, index) => {
              return (
                <div key={index} className={`${Style.clientTestimonialSubContainer}`}>
                  <div className={`${Style.imageContainer}`}>
                    <img className={`${Style.image}`} src={config.baseURL + item?.image}/>
                  </div>
                  <div className={`${Style.descriptionContainer}`}>{item?.title}</div>
                </div>
              );
            })}
          </div>
        )}
        {/* End of code - Ashlekh on 10-02-2025
        Reason - To display client testimonial details */}
      </div>
    </div>
  );
};

export default Review;
